import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.onDocumentClick = this.onDocumentClick.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
    document.addEventListener("click", this.onDocumentClick)
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
    document.removeEventListener("keydown", this.onKeydown)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    const wrap = event.currentTarget.closest(".sim-signoff-chip-wrap")
    if (!wrap) return

    const willOpen = !wrap.classList.contains("is-open")
    this.closeAll()
    if (willOpen) {
      wrap.classList.add("is-open")
      event.currentTarget.setAttribute("aria-expanded", "true")
    }
  }

  closeAll() {
    this.element.querySelectorAll(".sim-signoff-chip-wrap.is-open").forEach((wrap) => {
      wrap.classList.remove("is-open")
      const button = wrap.querySelector("button")
      if (button) button.setAttribute("aria-expanded", "false")
    })
  }

  onDocumentClick(event) {
    const open = this.element.querySelector(".sim-signoff-chip-wrap.is-open")
    if (!open || open.contains(event.target)) return

    this.closeAll()
  }

  onKeydown(event) {
    if (event.key === "Escape") this.closeAll()
  }
}
